import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDiscrepancyList } from "src/api/bi";
import {
  getPMRJITConfiguration,
  getProduceMovementRecord,
  postProduceMovementRecord
} from "src/api/sp";

import { getSearchProductsForJITOrder } from "src/api/common";

export const fetchProduceMovementRecord = createAsyncThunk(
  "goApps/fetchProduceMovementRecord",
  (payload: any) => getProduceMovementRecord(payload)
);

export const postingProduceMovementRecord = createAsyncThunk(
  "goApps/postProduceMovementRecord",
  (payload: any) => postProduceMovementRecord(payload)
);

export const searchProductsforJITOrder = createAsyncThunk(
  "searchProductsforJITOrder",
  ({
    searchQuery,
    departmentId,
    signal
  }: {
    searchQuery: string;
    departmentId: string;
    signal?: AbortSignal;
  }) =>
    getSearchProductsForJITOrder({
      searchTerm: searchQuery,
      departmentId,
      signal
    })
);

export const fetchPMRJITConfiguration = createAsyncThunk(
  "fetchPMRJITConfiguration",
  ({ storeId }: { storeId: string }) => getPMRJITConfiguration({ storeId })
);

export const fetchDiscrepancyList = createAsyncThunk(
  "fetchDiscrepancyList",
  ({
    storeId,
    orderDate,
    departmentId,
    signal
  }: {
    storeId: string;
    orderDate: string;
    departmentId: string;
    signal?: AbortSignal;
  }) => getDiscrepancyList({ storeId, orderDate, departmentId, signal })
);
